import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS_CONTACT } from './homeContent';

export function ContactLink({ children = 'Talk about your project', light = false }) {
  return <Link className={`home-cta${light ? ' home-cta-light' : ''}`} to={BUSINESS_CONTACT}>{children}<span aria-hidden="true">↗</span></Link>;
}

export function ServiceIcon({ name }) {
  const paths = {
    assessment: <><path d="M9 5H5v16h14V5h-4M9 3h6v4H9zM8 12h8M8 16h5" /></>,
    ai: <><rect x="7" y="7" width="10" height="10" rx="2" /><path d="M10 1v4m4-4v4m-4 14v4m4-4v4M1 10h4m-4 4h4m14-4h4m-4 4h4m-13-4h4v4h-4z" /></>,
    enterprise: <><path d="M4 21V3h11v18M15 9h5v12M8 7h3M8 11h3M8 15h3M2 21h20" /></>,
    applications: <><rect x="6" y="2" width="12" height="20" rx="2" /><path d="M10 5h4M11 19h2M10 10l-2 2 2 2m4-4 2 2-2 2" /></>,
    integration: <><rect x="2" y="3" width="7" height="6" rx="1" /><rect x="15" y="15" width="7" height="6" rx="1" /><path d="M9 6h9v6m-3-3 3 3 3-3M15 18H6v-6m-3 3 3-3 3 3" /></>,
    operations: <><path d="M4 12a8 8 0 0114-5l2 2M20 3v6h-6M20 12a8 8 0 01-14 5l-2-2M4 21v-6h6" /></>
  };
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{paths[name] || paths.enterprise}</svg>;
}
